// Logo Slider Section
$(document).ready(function(){
$('.logo__slider .logo__slider_slick').slick({
  infinite: false,
  arrows: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  dots: false,
  autoplay: false,
  autoplaySpeed: 2000,
  prevArrow: '<button class="slide-arrow prev-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 512.006 512.006" style="enable-background:new 0 0 512.006 512.006;" xml:space="preserve"><g><g><path d="M388.419,475.59L168.834,256.005L388.418,36.421c8.341-8.341,8.341-21.824,0-30.165s-21.824-8.341-30.165,0    L123.586,240.923c-8.341,8.341-8.341,21.824,0,30.165l234.667,234.667c4.16,4.16,9.621,6.251,15.083,6.251    c5.461,0,10.923-2.091,15.083-6.251C396.76,497.414,396.76,483.931,388.419,475.59z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
  nextArrow: '<button class="slide-arrow next-arrow slick-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 330 330" style="enable-background:new 0 0 330 330;" xml:space="preserve"><path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg></button>',
   responsive: [
    {
      breakpoint: 899,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 649,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
  ]
});
});



// Bundle
  $(document) .ready(function(){
    $(".add-btn").on("click", function() {
      var variantId = $(this).attr('variant');
      var currentTag = $(this);
      selectedVariant(currentTag, variantId);
      // $(this:has(".addtocart-collection-bundle")).siblings('.grid-view-item-image').find('.bundle__count_circle').addClass('selected');
      $(this).closest('.addtocart-collection-bundle').siblings('.grid-view-item-image').find('.bundle__count_circle').toggleClass('selected');

      if($(this).text() == 'Add Item'){
        $(this).text('Remove Item');
        $(this).addClass("selected");
      } else {
        $(this).text('Add Item');
        $(this).removeClass("selected");
      }

      var SelectedProCount  = 0;
      var AllSelectedProduct = $(`.addtocart-collection-bundle .selected`);
      if(AllSelectedProduct.length > 0){
        $(AllSelectedProduct).each(function(){
          SelectedProCount = AllSelectedProduct.length;
        });
        $(`.items_count`).removeClass('hide');
        $(`.checkbox__count`).html(SelectedProCount);
      } else{
        SelectedProCount  = 0;
        $(`.items_count`).removeClass('hide');
        $(`.checkbox__count`).html(SelectedProCount);
      }
    });

    function checkLimit(){
      var checkCount = [];
      var bundleLimit = $('#collection-bundle-product').attr('bundle-limit');
      let bundleCount  = 0;
      let all_quantities = $(".addtocart-collection-bundle .selected");
      if(all_quantities.length > 0){
        $(all_quantities).each(function(){
          bundleCount = all_quantities.length;
        });
      }else{
        bundleCount  = 0;
      }
      
      if( bundleCount >= bundleLimit) {
        $('#collection-bundle-product').removeClass("hide").prop('disabled',false);
        $('.addtocart-collection-bundle .add-btn').prop('disabled',true);
        $('.addtocart-collection-bundle .add-btn.selected').prop('disabled',false);
      } else {
        $('#collection-bundle-product').addClass("hide").prop('disabled',true);
        $('.addtocart-collection-bundle .add-btn').prop('disabled',false);
      }
    }

    function selectedVariant(currentTag, variantId){
      var variant= {};
      $('#collection-bundle-product').prop('disabled',true);
      //  $.getJSON(window.Shopify.routes.root + 'products/'+$(currentTag).attr('product-handle')+'.js', function(product) {
      //   $.each( product.variants, function( index, value ){
      //     if(value.id == variantId) {
      //       variant = value;
      //     }
      //   });
        
      //    checkLimit();
      //   // console.log(variant);
      // });
      fetch(window.Shopify.routes.root + 'products/'+$(currentTag).attr('product-handle')+'.js')
        .then(response => response.json())
        .then(product => {
            $.each( product.variants, function( index, value ){
          if(value.id == variantId) {
            variant = value;
          }
        });
        
         checkLimit();
        // console.log(variant);
        })
        .catch(error => {
            console.error('Error fetching the product:', error);
        });

    }
    
    $("#collection-bundle-product").on("click", function(event) {
      var formData = {};
      let items = [];
      let selected_bundles = $('.addtocart-collection-bundle .selected');
      for(let i = 0;i < selected_bundles.length;i++){
        let temp = {};
        let quantity = 1;
        let variant_id = $(selected_bundles[i]).attr("variant");
        temp['id'] = variant_id;
        temp['quantity'] = quantity;
        items.push(temp);
      }
      
      formData = {'items': items };
      addItemToCartCollection(formData);
    });

    function addItemToCartCollection(formData) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Failed to update cart quantity');
        }
      })
      .then(cart => {
        fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          // console.log('Cart updated:', cart);
          window.wetheme.updateCartDrawer(cart);
          // window.wetheme.showCart();
          window.wetheme.toggleRightDrawer('cart', true, {
          cart: cart
        });
        })
        .catch(error => {
          console.error('Error checking variant in cart:', error);
        });
        
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  });

// Collection Bundle Header Scroll
$(window).on('scroll', function(){
  var scroll = $(window).scrollTop();
  const mediaQuery = window.matchMedia('(min-width: 768px)');
  // if (mediaQuery.matches) {
    if (scroll >= 150) {
      if (isInView($(`.header-section--wrapper[data-header-sticky="true"]`))) {
        $(".bundle__sticky-header").addClass('sticky');
        
        let header = document.querySelector('.header-section--wrapper[data-header-sticky="true"]');
        let header_height = 0;
        if(header != undefined && header != null){
          header_height = header.offsetHeight - 1;
        }
        document.querySelector(".bundle__sticky-header").style.top = header_height+"px";
      }
      else{
        $(".bundle__sticky-header").removeClass('sticky');
      }
    }
    else{
      $(".bundle__sticky-header").removeClass('sticky');
    }
  // }else{
  //   $(".bundle__sticky-header").removeClass('sticky');
  //     document.querySelector(".bundle__sticky-header").style.top = "";
  // }
});

function isInView(element) {
    var elementTop = $(element).offset().top;
    var elementBottom = elementTop + $(element).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
}


// Product Page Personalise Popup Start

// Product Page Personalise Popup
$(document).ready(function(){
	$('.personalise-popup_btn').click(function(){
		$('.personalise__pop_ctn_container').show(); 
        $('body').addClass("freeze")
	});
	$('.personalise__pop_ctn_container .personalise_stat_popclose').click(function(){
		$('.personalise__pop_ctn_container').hide();
        $('body').removeClass('freeze');
	})
})


// Product Page Personalise initial Title Swatch
var personalise_initial_input = document.querySelector("#personalise_initial_input")
var personalise__result = document.querySelector("#personalise__result")

function personalise_initial_btn() {
  personalise__result.textContent = personalise_initial_input.value
}

function personalise__swatch(event) {
  var initialswatch = event.target.textContent
  document.getElementById("personalise_initial_input").setAttribute("type", initialswatch);
  
  var swatches = document.querySelectorAll(".personalise_initilax_swatch");
  swatches.forEach((swatch) => {
      swatch.classList.remove('click');
  });
  event.target.classList.add('click');
}

// Product Page Personalise Color Swatch
var personalise__colorswatch = document.querySelectorAll(".personalise__Colorswatch");
personalise__colorswatch.forEach((color_swatch) => {
    color_swatch.addEventListener('click', (e) => {
        var colorfinalvalue = e.currentTarget.getAttribute("data-color");
        document.querySelector('#personalise__result').style.color = colorfinalvalue;
      
        // personalise__result.setAttribute('data-color', colorfinalvalue);
      document.querySelector('#personalise__result').setAttribute('data-color', colorfinalvalue);
        personalise__colorswatch.forEach((swatch) => {
            swatch.classList.remove('click');
        });
        e.currentTarget.classList.add('click');
      
    });
});

// Product Page Personalise Font Swatch
var personalise__fontswatch = document.querySelectorAll(".personalise__Fontswatch");
personalise__fontswatch.forEach((font_swatch) => {
    font_swatch.addEventListener('click', (e) => {
        var fontfinalvalue = e.currentTarget.getAttribute("data-font");
        document.querySelector('#personalise__result').style.fontFamily = fontfinalvalue;
      
        // personalise__result.setAttribute('data-font', fontfinalvalue);
      document.querySelector('#personalise__result').setAttribute('data-font', fontfinalvalue);
        personalise__fontswatch.forEach((swatch) => {
            swatch.classList.remove('click');
        });
        e.currentTarget.classList.add('click');
    });
});

var personalise__customInitial = document.getElementById("personalise__customInitial")
var personalise__customcolor = document.getElementById("personalise__customcolor")
var personalise__customfont = document.getElementById("personalise__customfont")


function personalise_applyx_btn() {
  // personalise__customInitial.setAttribute("value", personalise_initial_input.value)
   personalise__customInitial.value = personalise_initial_input.value;
  
  var personalise__resultz = personalise__result.getAttribute("data-color")
  if(personalise__resultz == null){
  // personalise__customcolor.setAttribute("value", personalise__resultz)
  personalise__customcolor.setAttribute("value", "");
  }
  else{
  personalise__customcolor.setAttribute("value", personalise__resultz)
  }
  console.log("color:", personalise__resultz)
  
  var personalise_font_resultz = personalise__result.getAttribute("data-font")
  if(personalise_font_resultz == null){
  // personalise__customfont.setAttribute("value", personalise_font_resultz)
  personalise__customfont.setAttribute("value", "");
  }
  else{
  personalise__customfont.setAttribute("value", personalise_font_resultz)
  }
  
  // console.log("font:", personalise_font_resultz)
}

// Reset Button
function personalise_reset_btn() {
  personalise_initial_input.value=""
  personalise__result.textContent = personalise_initial_input.value
  
  personalise__result.style.color = "";
  personalise__result.removeAttribute('data-color');
  
  personalise__result.style.fontFamily = "";
  personalise__result.removeAttribute('data-font');
  
var swatches = document.querySelectorAll(".personalise__swatch");
swatches.forEach((swatch) => {
    swatch.classList.remove('click');
});

  personalise__customInitial.setAttribute("value", "");
  personalise__customcolor.setAttribute("value", "");
  personalise__customfont.setAttribute("value", "");
}
// Product Page Personalise Popup End


// Size Chart
$(document).ready(function(){
  $(".size__chartz .size__chartz_container .size__chartz_click__btn").click(function(){
    $(".size__chartz .size__chartz_container .size__chartz_modal__fade").show();
    $('body').addClass("freeze__overlay")
  });
  
  $(".size__chartz .size__chartz_container .size__chartz_modal__fade .close-icon").click(function(){
    $(".size__chartz .size__chartz_container .size__chartz_modal__fade").hide();
    $('body').removeClass("freeze__overlay")
  });
})